/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from "react";
import Select, { components } from "react-select";
import useWindowDimension from "../../components/hooks/useWindowDimension";
import DriverMangmentComponent from "./driverManagementComponent";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
// import "./driverManagement.scss";
import { useDispatch, useSelector } from "react-redux";
import { getDriverList, changeDriverDepot, changeDriverDepotReduxState } from "../../store/driverManagement/actions";
import { getDepotsList } from "../../store/depots/actions";


/**
 * A component for managing drivers.
 * @param {{object}} props - The component props.
 * @returns The DriverMangmentComponent with the necessary props.
 */
const DriverMangment = (props) => {
  const smarttableref = useRef();
  
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const driverList = useSelector((state) => state?.Driver?.driverList?.data);
  const depotList = useSelector((state) => state?.Depots?.depotsList?.data)
  const changeDepotBtnDisble = useRef(false);

  const dimensions = useWindowDimension();
  const [defaultValueSelectbox, setDefaultValueSelectbox] = useState([]);
  const [isMangerDepotName, setIsMangerDepotName] = useState([]);
  const [depotName, setDepotName] = useState({});

  const tableContainerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const pageSizeRef = useRef(20);

  const [tableFilterHeight, setTableFilterHeight] = useState("");
  const [headerHeight, setHeaderHeight] = useState("");
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [tabHeaderHeight, setTabHeaderHeight] = useState("");
  const [loaderHtml, setLoaderHtmlHeight] = useState("");
  const [placeHolder, setPlaceHolder] = useState(true);
  const [driverData, setDriverData] = useState([]);
  const [searchValue, setSearchValue] = useState(null);
  const depotlength = driverData?.length;

  /**
   * Loads more items when triggered, with a delay of 2000 milliseconds.
   * @returns None
   */
  const loadMoreItems = () => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      pageSizeRef.current += 2;
    }, 2000);
  };
  /**
   * Debounces the handleTableScroll function to prevent it from being called too frequently.
   * When the table container is scrolled, it checks if the scroll position is at the bottom
   * of the container. If it is, and there are more items to load, it calls the loadMoreItems function.
   * @returns None
   */
  const handleTableScroll = debounce(() => {
    const tableContainer = tableContainerRef?.current;
    if (tableContainer) {
      const isAtBottom =
        tableContainer?.scrollTop + tableContainer?.clientHeight >=
        tableContainer?.scrollHeight;
      if (isAtBottom && driverData?.length > pageSizeRef?.current) {
        loadMoreItems();
      }
    }
  }, 200);

  /**
   * Adds an event listener to the table container element to handle scroll events.
   * The event listener is removed when the component is unmounted.
   * @param {{function}} handleTableScroll - The function to handle the table scroll event.
   * @returns None
   */
  useEffect(() => {
    const tableContainer = tableContainerRef?.current;
    if (tableContainer) {
      tableContainer.addEventListener("scroll", handleTableScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleTableScroll);
      }
    };
  }, [handleTableScroll]);

  /**
   * Formats the label for an option in a select component.
   * @param {{label}} - The label of the option.
   * @returns A JSX element representing the formatted label.
   */
  const formatOptionLabel = ({ label }) => (
    <div className="selectWrapperDiv">
      <span>{label}</span>
    </div>
  );

  /**
   * useEffect hook that sets various heights based on the elements in the DOM.
   * @param {{boolean}} loading - Indicates whether the page is currently loading.
   * @returns None
   */
  useEffect(() => {
    loading &&
      setLoaderHtmlHeight(
        document.getElementsByClassName("infinate-load")[0].offsetHeight
      );
    setHeaderHeight(
      document.getElementsByClassName("navbar-header")[0].offsetHeight
    );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );
    setTableFilterHeight(
      document.getElementsByClassName("col-form-label")[0].offsetHeight
    );
    setTabHeaderHeight(document.getElementsByTagName("thead")[0].offsetHeight);
  }, [loading]);

  useEffect(() => {
    getList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Executes a side effect when the `driverList` dependency changes.
   * If `driverList` is not undefined, it sets the `driverData` state to the value of `driverList`.
   * @returns None
   */
  useEffect(() => {
   if (driverList !== undefined) {
      setDriverData(driverList.map((item) =>{ 
        return  {
          ...item,
           depotedit: false,
           depotname: item?.depotname?.map(i => ({ ...i, label: i?.depotname , value: i?.depotname  })),
           userId: item?.userid
          }}))
   }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driverList]);


  /**
   * Retrieves the driver list from the server and updates the state accordingly.
   * @returns None
   */
  const getList = () => {
    dispatch(getDriverList((res) => {
      setPlaceHolder(false);
    }, (err) => { console.log(err); }))
    dispatch(getDepotsList((res) => {
     
    }, (err) => { console.log(err); }))
  }

  const columns = [
    {
      label: (
        <>
          {t("DRIVER_NAME")} <span className="thCount">{depotlength}</span>
        </>
      ),
      key: "fullname",
      filter: false,
      sorter: true,
    },
    {
      label: <>{t("EMAIL_ADDRESS")}</>,
      key: "emailid",
      filter: false,
      sorter: true,
    },
    {
      label: <>{t("PHONE_NUMBER")}</>,
      key: "phone",
      filter: false,
      sorter: false,
    },
    {
      label: <>{t("PAY_NUMBER")}</>,
      key: "payno",
      filter: false,
      sorter: false,
    },
    {
      label: <>{t("DEPOT")}</>,
      key: "depotname",
      filter: (values, onChange) => {
        const unique = [...new Set(values)].sort();
        const _depotOptions = unique?.map((elementdepot) => elementdepot?.map((item) => ({
          label: item?.depotname,
          value: item?.depotname,
        })));
        /**
         * Filters and removes duplicate items from the depotOptions array and stores the unique items in the finalarr array.
         * @param {{Array}} _depotOptions - The array of depot options.
         * @returns None
         */
        let finalarr = []
        const depotOptions = _depotOptions?.flatMap((item) => item).sort((a, b) => a?.label?.localeCompare(b.label));
        depotOptions?.forEach((item) => { 
          let options = finalarr?.map(i => i.label);
          if (!options.includes(item?.label)) {
            finalarr.push(item)
          }
        })

        /**
         * Handles the change event for a selected value.
         * @param {{any}} selected - The selected value(s).
         * @returns None
         */
        const handleChange = (selected) => {
          const selectedValues = selected?.map(
            (elementdepot) => elementdepot?.value
          );
          onChange((item) => {
            const _filterValue = item?.filter((innerItem) => {
              if (selectedValues?.includes(innerItem?.depotname)) {
                return innerItem     
              }
            })
            return Array.isArray(selectedValues) && selectedValues?.length
              ? selectedValues?.includes(_filterValue[0]?.depotname)
              : true;
          });
        };
        /**
         * A custom option component for a select dropdown menu.
         * @param {{ReactNode}} children - The content of the option.
         * @param {{any}} props - Additional props for the option component.
         * @returns The custom option component.
         */
        const CustomOption = ({ children, ...props }) => {
          return (
            <components.Option {...props}>
              <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => {}}
              />
              <label for="checkbox">
                <span></span>
              </label>
              {children}
            </components.Option>
          );
        };

        return (
          <Select
            isMulti
            onChange={handleChange}
            closeMenuOnSelect={false}
            placeholder={t("SELECT")}
            isClearable
            options={finalarr}
            hideSelectedOptions={false}
            components={{ Option: CustomOption }}
            className="react-select-container multiSelecter"
            classNamePrefix="react-select"
          />
        );
      },
      sorter: false,
    },
    {
      label: <>{t("")}</>,
      key: "action",
      filter: false,
      sorter: false,
    },
  ];
  /**
   * Clears the search input field by programmatically clicking the clear button.
   * @returns None
   */
  const clearSearchButton = () => {
    smarttableref.current.querySelectorAll("button")[0].click();
  };
  const InputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isSelected,
    children,
    innerProps,
    ...rest
  }) => {
    const props = {
      ...innerProps,
    };

    return (
      <components.Option
        {...rest}
        isDisabled={isDisabled}
        isSelected={isSelected}
        getStyles={getStyles}
        innerProps={props}
      >
        <input type="checkbox" checked={isSelected} />
        <label for="checkbox">
          <span></span>
        </label>
        {children}
      </components.Option>
    );
  };
  /**
   * Handles the change event for a function.
   * @param {Event} e - The event object.
   * @param {any} item - The item being changed.
   * @param {boolean} data - The data associated with the change.
   * @returns None
   */


  const changeFuction = (e, item , data) => {
    setDepotName({ depotid: item?.depotname[0]?.depotid, label: item?.depotname[0]?.depotname, userId: item?.userid});
    setIsMangerDepotName({ depotid: item?.depotname[0]?.depotid, label: item?.depotname[0]?.depotname, userId: item?.userid});
    if (data === false) {
      setDriverData((prev) => {
        return prev.map((prevItem) => {
          if (prevItem?.userid === item?.userid) {
            return { ...prevItem, depotedit: !prevItem?.depotedit };
          } else {
            return prevItem;
          }
        });
      });  
    } else { 
      setDriverData((prev) => {
        return prev.map((prevItem) => {
          if (prevItem?.userid === item?.userid) {
            return { ...prevItem,  depotname: [ isMangerDepotName ] };
          } else {
            return prevItem;
          }
        });
      });
  
    }  
    if (item?.depotedit === true) {
        const depot = [ depotName?.depotid ]
        const params = {
          depotid: depot?.[0] === undefined ? [] : depot
        }
        if (!changeDepotBtnDisble.current) {
          changeDepotBtnDisble.current = true
          
          dispatch(changeDriverDepot(item?.userid, params, (res) => {    
            if (res) {
              const _upatedList = driverList?.map((innerItem) => {
                if (innerItem?.userid === isMangerDepotName?.userId) {
                  return { ...innerItem, depotname: [{depotid:depotName?.depotid, depotname: depotName?.label }] }
                }
                return innerItem;
              })
              dispatch(changeDriverDepotReduxState(_upatedList))
              changeDepotBtnDisble.current = false
            } 
          },(err) => {
            changeDepotBtnDisble.current = false
          }))
        }
    }
   
  };

  const onTableFilterChange = (filterText) => {
    setSearchValue(filterText);
  };
  const searchFilterClear = () => {
    smarttableref.current.querySelectorAll("button")[1].click();
  };

  return (
    <DriverMangmentComponent
      breadcrumbMainTitle={true}
      UserItem={driverData}
      addUserDepotName={depotList?.map((item) => {
        return{
          ...item,
          label: item?.name,
          value: item?.name,
        }
      })}
      components={{ Option: InputOption }}
      searchPlaceHolder={t("SEARCH_BY_NAME_OR_EMAIL_ADDRESS")}
      onChangeMangerDepot={(options) => {
        setDepotName(options)
      }}
      columns={columns}
      noDataDesc={t(
        "YOUR_SEARCH_DID_NOT_MATCH_ANY_USERS_PLEASE_TRY_SEARCHING_AGAIN"
      )}
      noDataTitle={t("NO_DRIVER_FOUND")}
      noDataFound={t("NO_DRIVER_FOUND")}
      noDataAddButton={true}
      placeHolderShimer={placeHolder}
      changeFuction={(e, item, data) => {
        changeFuction(e, item, data);
      }}
      onChangeDriverDepot={(options) => {
        setDefaultValueSelectbox(options?.map((opt) => {
          return {
                label: opt?.value,
                value: opt?.value,
          }
        }));
      }}
      smarttableref={smarttableref}
      dimensions={dimensions}
      headerHeight={headerHeight}
      breadcrumbHeight={breadcrumbHeight}
      tabHeaderHeight={tabHeaderHeight}
      tableFilterHeight={tableFilterHeight}
      formatOptionLabel={formatOptionLabel}
      clearSearchButton={clearSearchButton}
      tableContainerRef={tableContainerRef}
      itemsPerPage={pageSizeRef.current}
      loading={loading}
      loaderHtml={loaderHtml}
      defaultValue={defaultValueSelectbox}
      onTableFilterChange={onTableFilterChange}
      searchValue={searchValue}
      searchFilterClear={searchFilterClear}
    />
  );
};

export default DriverMangment;
